const VrioContentType = {
  CHANNEL: "LIVE",
  SHOW: "SERIE",
  MOVIE: "MOVIE",
  EPISODE: "EPISODE",
  EVENT: "SHOW",
  SPORT: "SPORT"
};
const BlimResourceType = {
  SHOW: "SHOW",
  MOVIE: "MOVIE",
  EPISODE: "EPISODE",
  SERIE: "SERIE",
  LIVE_MOVIE: "LIVE_MOVIE",
  LIVE_EPISODE: "LIVE_EPISODE",
  LIVE_SERIE: "LIVE_SERIE"
};
const PageType = {
  HOME: "HOME",
  VOD: "VOD",
  SPORTS: "SPORTS",
  LIVE: "LIVE",
  KIDS: "KIDS",
  BLIM: "BLIM",
  SEARCH: "SEARCH"
};
const ContentType = {
  EPG: 1,
  VOD: 2
};
const MILLISECONDS_IN_A_SECOND = 1e3;
const SECONDS_IN_A_MINUTE = 60;
const MINUTES_IN_AN_HOUR = 60;
const HOURS_IN_A_DAY = 24;
const DEFAULT_FORMAT_TIME_TEXTS = {
  texts: {
    startsAt: "Comienza en",
    endsIn: "Termina en"
  },
  time: {
    day: {
      today: "Hoy",
      tomorrow: "Ma\xF1ana",
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Mi\xE9rcoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "S\xE1bado",
      sunday: "Domingo"
    },
    hours: {
      singular: "h",
      plural: "hs"
    },
    minutes: "min"
  }
};

export { BlimResourceType, ContentType, DEFAULT_FORMAT_TIME_TEXTS, HOURS_IN_A_DAY, MILLISECONDS_IN_A_SECOND, MINUTES_IN_AN_HOUR, PageType, SECONDS_IN_A_MINUTE, VrioContentType };
//# sourceMappingURL=index.js.map
